import styled from "styled-components";

export const Button = styled.button`
  border-radius: 10px;
  background-color: rgb(0,212,212);
  cursor: pointer;
  color: #fff;
  border: none;
  padding: 10px 20px 10px 20px;
  font-size:15px;
  font-weight:600;
  span{
    margin-left:5px;
  }
  &:hover{
    background-color: #42f5ec;
  }
`